// extracted by mini-css-extract-plugin
export default {"headerContentContainerImaged":"UiContainer_headerContentContainerImaged__QOCkJ","headerImg":"UiContainer_headerImg__-pAmk"};